<template>
  <MapComponent />
</template>

<script>
import MapComponent from '@/components/Map.vue';

export default {
  name: 'Name',
  components: {
    MapComponent,
  },
};
</script>
